import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './device_config_create.routes';
import SaConfigService from '../../../../components/api/sa_config/sa_config.service';
import DistStockService from '../../../../components/api/dist_stock/dist_stock.service';
import CompanyService from '../../../../components/api/company/company.service';
import ZipSearchLogic from "../../../../components/logic/zip-search/zip-search.logic";

export class OemDeviceConfigCreateController {
  /*@ngInject*/
  constructor(SaConfigService, CompanyService, $state, $stateParams, $scope, $timeout, $mdDialog, DistStockService, ZipSearchLogic) {
    this.deviceConfig = {
      mode: 'reading_only',
      wlan_enabled: false,
      company_id: $stateParams.company_id,
      carrier_port: 'emobile0',
      distribution_id: '',
      demand_dead_duration: 600,
      demand_level_down_count: 3,
      remoteio_name: 'panasonic-uenu2d4r12'
    };
    this.SaConfigService = SaConfigService;
    this.DistStockService = DistStockService;
    this.CompanyService = CompanyService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.company_id = $stateParams.company_id;
    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか?',
        ok: '作成する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '作成しました',
        content: '端末一覧 画面に移動します',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', current => {
      if (current) {
        this.ZipSearchLogic.get(current).then(address => {
          $timeout(() => {
            this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  $onInit() {
    this.DistStockService.oem_api.index((response) => {
      this.deviceStocks = response.dist_stocks;
    });

    this.CompanyService.show({id: this.company_id}, response => {
      this.company = response;
    }, err => {
      if (err.status === 404 || err.status === 403) {
        this.$state.go('oem_main.oem_home');
      }
    });
  }

  showConfirm(deviceConfig, ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        deviceConfig.base_unit_price = deviceConfig.base_unit_price || 0;
        deviceConfig.power_unit_price = deviceConfig.power_unit_price || 0;
        this.SaConfigService.oem_api.create(
          deviceConfig,
          (okResponse) => { this.$mdDialog.show(this.dialog.success).finally(() => this.$state.go('oem_main.device_index', {company_id: this.company_id})); },
          (errResponse) => { this.$mdDialog.show(this.dialog.error.content(errResponse.data.message)); }
        );
      });
  }
}

export default angular.module('leptonApp.oemDeviceConfigCreate', [uiRouter, SaConfigService, DistStockService, CompanyService, ZipSearchLogic])
  .config(routing)
  .component('oemDeviceConfigCreate', {
    template: require('./device_config_create.html'),
    controller: OemDeviceConfigCreateController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/create/device_config_create.component.js